import { createRef, Fragment, h } from "preact";
import { useLayoutEffect, useState } from "preact/hooks";

import tracking from "../tracking/tracking";
import i18n from "../i18n";

import Button from "./Button.jsx";
import Overlay from "./Overlay.jsx";

export default function WithConfirmation({
  title,
  cancelButton,
  trackingName,
  trackingParams,
  trigger,
  okButtonDanger,
  okButton,
  onSuccess,
  onCancel,
  onOpen,
}) {
  const dialogRef = createRef();
  const overlayRef = createRef();
  const [opened, setOpened] = useState(false);

  useLayoutEffect(() => {
    if (!overlayRef.current || !dialogRef.current) {
      return;
    }
    // TODO: Some of this stuff should belong to Overlay and some should go into a
    //       general Dialog component
    const overlay = overlayRef.current.base;
    overlay.classList.add("overlay--open");
    const wrapper = dialogRef.current;
    wrapper.classList.add("dialog--open");
    wrapper.addEventListener(
      "animationend",
      () => {
        onOpen && onOpen();
      },
      { once: true } // Does not work in IE, but who cares
    );
  }, [dialogRef, overlayRef]);

  useLayoutEffect(() => {
    if (!overlayRef.current || !dialogRef.current) {
      return;
    }
    const overlay = overlayRef.current.base;
    const wrapper = dialogRef.current;

    return () => {
      overlay.classList.add("overlay--exit");
      wrapper.classList.add("dialog--exit");

      return new Promise(function (resolve) {
        wrapper.addEventListener("animationend", resolve);
      });
    };
  }, []);

  const trackingPrefix = trackingName || "withConfirmationDialog";

  function handleOpenClick(event) {
    event.preventDefault();
    tracking.track("button.click", {
      name: `${trackingPrefix}.trigger`,
      ...(trackingParams || {}),
    });
    setOpened(true);
  }

  function handleSuccessClick(event) {
    event.preventDefault();

    tracking.track("button.click", {
      name: `${trackingPrefix}.ok`,
      ...(trackingParams || {}),
    });
    setOpened(false);

    if (onSuccess) {
      onSuccess(event);
    }
  }
  function handleCancelClick(event) {
    event.preventDefault();

    tracking.track("button.click", {
      name: `${trackingPrefix}.cancel`,
      ...(trackingParams || {}),
    });
    setOpened(false);

    if (onCancel) {
      onCancel(event);
    }
  }

  return (
    <>
      {trigger(handleOpenClick)}
      {opened && (
        <Overlay ref={overlayRef}>
          <section class="dialog dialog--md  card" ref={dialogRef}>
            <h3 className="t-subtitle1 t-subtitle1--margin">{title}</h3>

            <div class="dialog__buttonRow">
              <Button danger={okButtonDanger} onClick={handleSuccessClick}>
                {okButton || i18n.t("actions.ok")}
              </Button>
              <Button secondary onClick={handleCancelClick} class="mr-8">
                {cancelButton || i18n.t("actions.cancel")}
              </Button>
            </div>
          </section>
        </Overlay>
      )}
    </>
  );
}
